<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="Steps">
      <Steps :current="current" :status="status">
        <Step title="提交资料"></Step>
        <Step title="资料审核"></Step>
        <Step title="审核结果"></Step>
      </Steps>
    </div>
    <div v-show="current === 0" style="margin-left:80px;margin-bottom:20px;">
      <div>开发者类型</div>
      <RadioGroup v-model="developType" @on-change="radioChange">
            <Radio label="企业"></Radio>
            <Radio label="个人开发者"></Radio>
        </RadioGroup>
    </div>
    <div v-if="current === 0 && developType === '企业'">
      <Form ref="formValidate" :model="formValidate" :label-width="150">
        <FormItem label="企业名称" prop="name">
          <Input v-model="formValidate.name" style="width: 400px" placeholder="名称需与工商营业执照企业名称相同" />
        </FormItem>
        <FormItem label="企业简称" prop="name_short">
          <Input v-model="formValidate.name_short" style="width: 400px" placeholder="如：北京汗粮科技有限公司，简称：汗粮科技" />
        </FormItem>
        <FormItem label="联系电话" prop="mobile">
          <Input type="text" v-model="formValidate.mobile" style="width: 400px" placeholder="座机或手机，请确保审核人员可以联系到您！" />
        </FormItem>
        <FormItem label="邮箱" prop="email">
          <Input type="email" v-model="formValidate.email" style="width: 400px" placeholder="请输入企业邮箱，方便接收最新的升级信息！" />
        </FormItem>
        <FormItem label="网站" prop="website">
          <Input type="url" v-model="formValidate.website" style="width: 400px" placeholder="请输入您的企业官网或产品官网地址，如暂时没有填写“无”！" />
        </FormItem>
        <FormItem label="工商营业执照扫描件" prop="licence">
          <!-- <div class="picWrap" v-for="(item, index) in formValidate.licence" :key="index">
            <img :src="item" width="100%">
            <Icon class="clearPic" size="25" type="md-close-circle" @click="clearPic(index)" />
          </div> -->
          <div class="picWrap" v-show="formValidate.licence.length !== 0">
            <img :src="formValidate.licence" width="100%">
            <Icon class="clearPic" size="25" type="md-close-circle" @click="clearPic" />
          </div>
          <div>
            <label class="file-wrap">
              <input class="file-input" type="file" ref="file" accept="image/png, image/jpeg"
                     multiple="multiple" @change="uploadImg('file')" />
              <Button icon="ios-cloud-upload-outline">上传文件</Button>
            </label>
          </div>
          <div class="tips">支持jpg/png格式文件，不超过5M（复印件需加盖公章）</div>
        </FormItem>
        <FormItem class="form-item">
          <Checkbox v-model="agree"></Checkbox> <a target="_blank" href="/static/legal.html">《快应用服务协议及用户隐私声明》</a>
        </FormItem>
        <FormItem>
          <Button :loading="loading" type="primary" @click="submit">确定</Button>
        </FormItem>
      </Form>
    </div>
    <div v-if="current === 0 && developType === '个人开发者'">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate1" :label-width="150">
        <FormItem label="姓名" prop="name">
          <Input v-model="formValidate.name" style="width: 400px" placeholder="请输入开发者名称" />
          <p class="rule-color" v-show="showName">请输入正确的名称</p>
        </FormItem>
        <FormItem label="身份证号" prop="idno">
          <Input v-model="formValidate.idno" style="width: 400px" placeholder="请输入正确的身份证号" />
          <p class="rule-color" v-show="showIdno">请输入正确的身份证号</p>
        </FormItem>
        <FormItem label="手机号" prop="mobile">
          <Input type="text" v-model="formValidate.mobile" style="width: 400px" placeholder="请输入手机号，请确保审核人员可以联系到您！" />
          <p class="rule-color" v-show="showTel">请输入正确的手机号</p>
        </FormItem>
        <FormItem label="邮箱" prop="email">
          <Input type="email" v-model="formValidate.email" style="width: 400px" placeholder="请输入邮箱，方便接收最新的升级信息！" />
          <p class="rule-color" v-show="showEmail">请输入正确的邮箱</p>
        </FormItem>
        <FormItem class="form-item">
          <Checkbox v-model="agree"></Checkbox> <a target="_blank" href="/static/legal.html">《快应用服务协议及用户隐私声明》</a>
        </FormItem>
        <FormItem>
          <Button :loading="loading" type="primary" @click="submit">确定</Button>
        </FormItem>
      </Form>
    </div>
    <div class="result" v-else-if="current === 1">您已提交审核信息，请等待审核结果</div>
    <div class="result" v-else>
      <div v-if="formValidate.status === 1">恭喜！ 您的开发者资料审核已通过</div>
      <div v-if="formValidate.status === 2">
        <div class="spacingTwice">
          <p>您提交的信息未通过审核</p>
          <p class="errorColor" v-if="formValidate.aduit_con">未通过原因：{{formValidate.aduit_con}}</p>
        </div>
        <Button type="primary" @click="current = 0">重新提交资料</Button>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
export default {
  name: 'certification',
  data () {
    return {
      loading: false,
      agree: true,
      current: 0,
      status: 'process',
      developType: '企业',
      showName: false,
      showIdno: false,
      showTel: false,
      showEmail: false,
      formValidate: {
        name: '',
        name_short: '',
        mobile: '',
        email: '',
        website: '',
        licence: [],
        status: 0,
        idno: ''
      },
      ruleValidate1: {
        // name: [
        //   { required: true, message: '请输入正确的名称', trigger: 'blur' }
        // ],
        // idno: [
        //   { required: true, pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输正确的身份证号', trigger: 'blur' }
        // ],
        // mobile: [
        //   { required: true, pattern: /^1[3456789]\d{9}$/, message: '请输入正确的联系电话。', trigger: 'blur' }
        // ],
        // email: [
        //   { required: true, message: '请输入邮箱', trigger: 'blur' },
        //   { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        // ]
        // website: [
        //   { required: true, message: '请输入网站', trigger: 'blur' }
        // ],
        // licence: [
        //   { required: true, message: '请上传企业营业执照' }
        // ]
        // licence: [
        //   { required: true, type: 'array', min: 1, message: '请上传企业营业执照' }
        // ]
      }
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    https.request({
      method: 'get',
      // url: '/v1/qualification/get'
      url: '/v2/es/account/qualification'
    }).then(res => {
      if (res.code === 400) {
        this.current = 0
        this.status = 'process'
        this.formValidate.status = 0
      }
      if (res.data) {
        this.formValidate = {
          name: res.data.name,
          name_short: res.data.name_short,
          mobile: res.data.mobile,
          email: res.data.email,
          idno: res.data.idno,
          licence: res.data.licence || [],
          status: res.data.status,
          aduit_con: res.data.aduit_con,
          website: res.data.website
        }
        if (res.data.status === 1) {
          this.current = 2
          this.status = 'finish'
        } else if (res.data.status === 2) {
          this.current = 2
          this.status = 'error'
        } else if (res.data.status === 0) {
          this.current = 1
          this.status = 'process'
        }
        if (res.data.idno.length > 0) {
          this.developType = '个人开发者'
        }
        this.formValidate.status = res.data.status
      }
    }).catch(error => {
      console.log(error)
      // this.$Message.error(error)
    })
  },
  methods: {
    radioChange (val) {
      this.developType = val
    },
    uploadImg (name) {
      let file = this.$refs[name].files
      let length = file.length
      let params = new FormData()
      for (let i = 0; i < length; i++) {
        params.append('file', file[i])
      }
      https.request({
        method: 'post',
        // url: '/v1/basic/file',
        url: '/v2/es/audit/upload/licence',
        data: params
      }).then(res => {
        // if (!this.formValidate.licence) this.formValidate.licence = []
        // res.data.forEach(n => {
        this.formValidate.licence = res.data
        // })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    clearPic (index) {
      // this.formValidate.licence.splice(index, 1)
      this.formValidate.licence = ''
    },
    submit () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.loading = true
          // let params = new FormData()
          let params = {}
          let url = ''
          if (this.developType === '企业') {
            url = '/v2/es/audit/company'
            params = {
              name: this.formValidate.name,
              name_short: this.formValidate.name_short,
              mobile: this.formValidate.mobile,
              email: this.formValidate.email,
              website: this.formValidate.website,
              licence: this.formValidate.licence
            }
            https.request({
              method: 'post',
              url: url,
              data: params
            }).then(res => {
              if (res.code === 400) {
                this.loading = false
                this.$Message.error(res.message)
                return
              }
              this.$Message.success({
                content: '提交成功',
                onClose: () => {
                  this.loading = false
                  this.current = 1
                }
              })
            }).catch(error => {
              this.$Message.error(error)
              this.loading = false
            })
          } else {
            let email = /^\w+@[a-z0-9]+\.[a-z]+$/i
            if (this.formValidate.name.length === 0) {
              console.log('name')
              this.showName = true
              this.loading = false
              return
            } else {
              this.showName = false
            }
            if (this.formValidate.idno.length !== 18) {
              console.log('idno')
              this.showIdno = true
              this.loading = false
              return
            } else {
              this.showIdno = false
            }
            if (this.formValidate.mobile.length !== 11) {
              console.log('mobile')
              this.showTel = true
              this.loading = false
              return
            } else {
              this.showTel = false
            }
            if (email.test(this.formValidate.email) === false) {
              console.log('email')
              this.showEmail = true
              this.loading = false
              return
            } else {
              this.showEmail = false
            }
            url = '/v2/es/audit/developer'
            params = {
              name: this.formValidate.name,
              idno: this.formValidate.idno,
              mobile: this.formValidate.mobile,
              email: this.formValidate.email
            }
            https.request({
              method: 'post',
              url: url,
              data: params
            }).then(res => {
              if (res.code === 400) {
                this.loading = false
                this.$Message.error(res.message)
                if (res.message.indexOf('身份证') > -1) {
                  this.showIdno = true
                  this.loading = false
                }
                if (res.message.indexOf('手机') > -1) {
                  this.showTel = true
                  this.loading = false
                }
                if (res.message.indexOf('邮箱') > -1) {
                  this.showEmail = true
                  this.loading = false
                }
                return
              }
              this.$Message.success({
                content: '提交成功',
                onClose: () => {
                  this.loading = false
                  this.current = 1
                }
              })
            }).catch(error => {
              this.$Message.error(error)
              this.loading = false
            })
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .Steps {
    width: 600px;
    margin: 50px auto;
  }
  .result {
    font-size: 18px;
    text-align: center;
    padding: 100px 0;
  }
  .picWrap {
    display: inline-block;
    width: 300px;
    position: relative;
    margin-right: 10px;
  }
  .clearPic {
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .rule-color{
    color:#c00;
  }
</style>



// WEBPACK FOOTER //
// src/components/certification.vue